// ================ Action types ================ //

import axios from 'axios';
import { languageSelectOptions, NATIVE_LANG_STORAGE_KEY } from '../config/configLanguage';
import { apiBaseUrl } from '../util/api';
import { storedData } from '../util/languageStorageHelper';

export const DISABLE_SCROLLING = 'app/ui/DISABLE_SCROLLING';
export const CHANGE_USER_NATIVE_LANG = 'app/UI/CHANGE_USER_NATIVE_LANG';

// ================ Reducer ================ //

const initialState = {
  disableScrollRequests: [],
  userNativeLang: storedData(NATIVE_LANG_STORAGE_KEY) || languageSelectOptions.en.value,
};

export default function reducer(state = initialState, action = {}) {
  state = state || {
    ...initialState,
    userNativeLang: storedData(NATIVE_LANG_STORAGE_KEY) || languageSelectOptions.en.value,
  };

  const { type, payload } = action;
  switch (type) {
    case DISABLE_SCROLLING: {
      const { componentId, disableScrolling } = payload;
      const disableScrollRequests = state.disableScrollRequests;
      const componentIdExists = disableScrollRequests.find(c => c.componentId === componentId);

      if (componentIdExists) {
        const disableScrollRequestArray = disableScrollRequests.map(c => {
          return c.componentId === componentId ? { ...c, disableScrolling } : c;
        });
        return { ...state, disableScrollRequests: [...disableScrollRequestArray] };
      }

      const disableScrollRequestArray = [
        ...disableScrollRequests,
        { componentId, disableScrolling },
      ];
      return {
        ...state,
        disableScrollRequests: disableScrollRequestArray,
      };
    }
    case CHANGE_USER_NATIVE_LANG:
      return { ...state, userNativeLang: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const manageDisableScrolling = (componentId, disableScrolling) => ({
  type: DISABLE_SCROLLING,
  payload: { componentId, disableScrolling },
});

// /native-lang/adeptu;
// ================ Selectors ================ //

export const isScrollingDisabled = state => {
  const { disableScrollRequests } = state.ui;
  return disableScrollRequests.some(r => r.disableScrolling);
};

// ============= Action creator ================//

export const changeUserNativeLang = payload => (dispatch, getState, sdk) => {
  const { isAuthenticated } = getState().auth;
  if (!isAuthenticated) {
    dispatch({ type: CHANGE_USER_NATIVE_LANG, payload });
    return;
  }
  const currentLang = getState().ui.userNativeLang;
  dispatch({ type: CHANGE_USER_NATIVE_LANG, payload });
  const url = `${apiBaseUrl(process.env.REACT_APP_MARKETPLACE_ROOT_URL)}/api/native-lang/update`;
  return axios
    .post(url, { nativeLang: payload }, { withCredentials: true })
    .then(resp => {
      dispatch({ type: CHANGE_USER_NATIVE_LANG, payload });
    })
    .catch(err => {
      dispatch({ type: CHANGE_USER_NATIVE_LANG, payload: currentLang });
    });
};
